import { SavingsGoal } from '../../types/bank';
import { PiggyBank } from 'lucide-react';

type Props = {
  goals: SavingsGoal[];
};

export default function SavingsGoals({ goals }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {goals.map(goal => {
        const progress = (goal.currentAmount / goal.targetAmount) * 100;
        return (
          <div
            key={goal.id}
            className="bg-white/60 backdrop-blur-md rounded-xl shadow-sm border border-gray-200/50 p-6"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-gray-50 rounded-lg">
                  {goal.icon}
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">{goal.name}</h3>
                  <p className="text-sm text-gray-500">
                    Due {new Date(goal.deadline).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric'
                    })}
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Progress</span>
                <span className="font-medium text-gray-800">
                  {goal.currentAmount} / {goal.targetAmount} pts
                </span>
              </div>

              <div className="w-full bg-gray-100 rounded-full h-2">
                <div
                  className="h-2 rounded-full bg-green-500"
                  style={{ width: `${progress}%` }}
                />
              </div>

              <button className="w-full bg-gray-800/90 text-white py-2 px-4 rounded-lg text-sm font-medium hover:bg-gray-900 transition-all backdrop-blur-sm flex items-center justify-center gap-2">
                <PiggyBank className="w-4 h-4" />
                Add to Goal
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}